import Cookies from 'js-cookie';

import isBrowser from './isBrowser';
import { PageMetatag } from '../types/types';

export const initialLandingPage = () => {
  const lucidChartSparkRegex = new RegExp(/^https?:\/\/(.*)(www\.)?lucid(chart|spark)/gi);
  const { origin, pathname } = window.location;
  const url = `${origin}${pathname}`;
  const cookie = Cookies.get('initialLandingPage');
  let sessionInitialLandingPage = '';

  if (!window.sessionStorage.initialLandingPage && !cookie) {
    Cookies.set('initialLandingPage', url);
    return window.sessionStorage.initialLandingPage = url;
  }

  if (window.sessionStorage.initialLandingPage) {
    sessionInitialLandingPage = url;
  }

  if ((url.match(lucidChartSparkRegex) && cookie) && !sessionInitialLandingPage) {
    Cookies.set('initialLandingPage', url);
    return window.sessionStorage.initialLandingPage = url;
  }
};

export const getUsernameCookie = () => {
  const username = isBrowser()
    ? window.atob(Cookies.get('username') || '')
    : undefined;

  return username;
};

export const setMetatagCookies = (metatags?: PageMetatag[] | null) => {
  if (isBrowser()) {
    const setCookie = metatags?.find(tag => tag.key === 'set-cookie');
    const cookieData = setCookie?.value && setCookie?.value.match(/=/gi)
      ? setCookie?.value.split('=')
      : [setCookie?.value];

    if (cookieData && cookieData[0]) {
      Cookies.set(cookieData[0], cookieData[1] || 'true');
    }
  }
};
